import { render } from "./PanelMesas.vue?vue&type=template&id=31046a0c&scoped=true"
import script from "./PanelMesas.vue?vue&type=script&lang=js"
export * from "./PanelMesas.vue?vue&type=script&lang=js"

import "./PanelMesas.vue?vue&type=style&index=0&id=31046a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31046a0c"]])

export default __exports__